import { useToast } from '@lifebit-ai/lds'
import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { extractErrorMessage } from 'core/utils'
import { deleteDataAccessRequestLabel } from 'services/data-access-requests'
import type { DeleteDataAccessRequestLabelParams } from 'services/data-access-requests/types'
import type { ApiErrorResponse } from 'services/types'
import { isAirlockRequestsV3RoutesEnabled } from 'utils/env'

/** mutation-cache: synced by the caller (useDataAccessRequestDetails onSuccess): label filter, request verification and activity queries */
export const useDeleteDataAccessRequestLabel = (
  requestId: string,
  options?: Omit<UseMutationOptions<void, ApiErrorResponse, DeleteDataAccessRequestLabelParams>, 'mutationFn'>
) => {
  const toast = useToast()

  return useMutation<void, ApiErrorResponse, DeleteDataAccessRequestLabelParams>({
    onError: error => {
      toast({ message: extractErrorMessage(error, 'Failed to remove label'), type: 'error' })
    },
    ...options,
    mutationFn: params => {
      if (!isAirlockRequestsV3RoutesEnabled()) {
        return Promise.resolve()
      }

      return deleteDataAccessRequestLabel(requestId, params.labelId)
    }
  })
}
